import { render, staticRenderFns } from "./copitext-cell.vue?vue&type=template&id=0152a491"
import script from "./copitext-cell.vue?vue&type=script&lang=js"
export * from "./copitext-cell.vue?vue&type=script&lang=js"
import style0 from "./copitext-cell.vue?vue&type=style&index=0&id=0152a491&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports